import { useEffect, useState } from "react";
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    TextField, Button, Checkbox, FormControlLabel, Grid, Box,
    Card, CardMedia, CardContent, Typography
} from "@mui/material";


export default function PostDialog({
    open: isOpen,
    setOpenForm,
    formData,
    setFormData,
    editingId,
    loading = false,
    handleSubmit,
    errors,
    setErrors
}) {
    //  const [loading, setLoading] = useState(false);

    // NUEVO: preview del archivo local
    const [filePreview, setFilePreview] = useState(null);

    // Si subís archivo, generamos la URL temporal y la guardamos para el preview
    const handleFile = (e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        const url = URL.createObjectURL(file);
        // si había una URL previa, liberarla
        setFilePreview(prev => {
            if (prev) URL.revokeObjectURL(prev);
            return url;
        });

        // si querés además guardar el archivo en tu formData:
        setFormData(prev => ({ ...prev, thumbnail: file }));
    };

    // Limpieza de la URL temporal al desmontar
    useEffect(() => {
        return () => {
            if (filePreview) URL.revokeObjectURL(filePreview);
        };
    }, [filePreview]);

    // Imagen que usa el preview: primero archivo local, después URL del form
    const previewImage =
        filePreview || (formData?.thumbnail?.trim() ? formData?.thumbnail?.trim() : undefined);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));

        setErrors?.((prev) => {
            const { [name]: _omit, ...rest } = prev || {};
            return rest;
        });
    };

    return (
        <Dialog open={isOpen} onClose={() => setOpenForm(false)} fullWidth maxWidth="md">
            <DialogTitle>{editingId ? "Editar publicación" : "Nueva publicación"}</DialogTitle>

            <DialogContent dividers sx={{ mt: 1 }}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={7} sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                        <TextField
                            label="Descripción"
                            name="description"
                            value={formData?.description || ""}
                            onChange={handleChange}
                            fullWidth
                        />
                        {errors.description && (
                            <Typography variant="caption" color="error">
                                {errors.description}
                            </Typography>
                        )}
                        <TextField
                            label="Subtitulo (opcional)"
                            name="note"
                            value={formData?.note || ""}
                            onChange={handleChange}
                            fullWidth
                        />
                        <TextField
                            label="Link de Redirección (Obligatorio)"
                            name="redirectlink"
                            value={formData?.redirectlink || ""}
                            onChange={handleChange}
                            fullWidth
                        />
                        {errors.thumbnail && (
                            <Typography variant="caption" color="error">
                                {errors.redirectlink}
                            </Typography>
                        )}
                        <TextField
                            label="URL de Imagen (Thumbnail)"
                            name="thumbnail"
                            value={formData?.thumbnail || ""}
                            onChange={handleChange}
                            placeholder="https://... (opcional si subís archivo abajo)"
                            fullWidth
                        />
                        {errors.thumbnail && (
                            <Typography variant="caption" color="error">
                                {errors.thumbnail}
                            </Typography>
                        )}
                        <div>
                            <small>o subí un archivo:</small>
                            <input type="file" accept="image/*" onChange={handleFile} />
                        </div>

                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={!!formData?.hidden}
                                    onChange={(e) => setFormData((prev) => ({ ...prev, hidden: e.target.checked }))}
                                    name="hidden"
                                />
                            }
                            label="Oculto"
                        />
                    </Grid>

                    <Grid item xs={12} md={5}>
                        <Typography variant="overline" sx={{ display: "block", mb: 1 }}>
                            Preview en teléfono
                        </Typography>

                        <Box
                            sx={{
                                width: 320,
                                mx: "auto",
                                borderRadius: 5,
                                p: 1.5,
                                position: "relative",
                            }}
                        >
                            <Box
                                sx={{
                                    position: "absolute",
                                    top: 6,
                                    left: "50%",
                                    transform: "translateX(-50%)",
                                    width: 80,
                                    height: 6,
                                    bgcolor: "white",
                                    borderRadius: 3,
                                }}
                            />
                            <Card sx={{ position: "relative", borderRadius: 0, overflow: "hidden", boxShadow: 6 }}>
                                {previewImage ? (
                                    <CardMedia
                                        component="img"
                                        height="160"
                                        image={previewImage}
                                        alt="thumbnail"
                                        onError={(e) => {
                                            e.currentTarget.src =
                                                "data:image/svg+xml;charset=UTF-8," +
                                                encodeURIComponent(
                                                    `<svg xmlns='http://www.w3.org/2000/svg' width='600' height='300'><rect width='100%' height='100%' fill='#eee'/><text x='50%' y='50%' dominant-baseline='middle' text-anchor='middle' fill='#999' font-size='20'>Sin imagen</text></svg>`
                                                );
                                        }}
                                    />
                                ) : (
                                    <Box
                                        sx={{
                                            height: 160,
                                            bgcolor: "#f2f2f2",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }}
                                    >
                                        <Typography variant="caption" color="text.secondary">
                                            Sin imagen
                                        </Typography>
                                    </Box>
                                )}

                                <CardContent sx={{ py: 1.5 }}>
                                    <Typography variant="body2" color="text.primary" sx={{ mb: 1 }}>
                                        {formData?.description?.trim() || "Sin descripción"}
                                    </Typography>
                                    <Typography variant="body2" color="text.primary" sx={{ mb: 1 }}>
                                        {formData?.note?.trim() || "Sin subtitulo"}
                                    </Typography>

                                </CardContent>

                                {formData?.hidden && (
                                    <Box
                                        sx={{
                                            position: "absolute",
                                            inset: 0,
                                            bgcolor: "rgba(0,0,0,0.45)",
                                            color: "#fff",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            fontWeight: 700,
                                            letterSpacing: 1,
                                        }}
                                    >
                                        OCULTO
                                    </Box>
                                )}
                            </Card>
                        </Box>
                    </Grid>
                </Grid>
            </DialogContent>

            <DialogActions>
                <Button onClick={() => setOpenForm(false)} disabled={loading}>
                    Cancelar
                </Button>
                <Button variant="contained" onClick={handleSubmit} disabled={loading}>
                    {editingId ? "Guardar cambios" : "Guardar"}
                </Button>
            </DialogActions>
        </Dialog>

    );
}
